<div class="modal-header">
  <h5 class="modal-title">{{ title }}</h5>
  <button type="button" class="close basic-close" (click)="onClose()" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<form autocomplete="off" [formGroup]="form" (ngSubmit)="onConfirme()">
  <div class="modal-body">

    <div class="col-md-12">
      <div class="row">
        <span class="badge badge-primary my-2 f-14 formBadge width">
          Sélection du client
        </span>
      </div>

      <!-- Sélection du client -->
      <div class="row mb-4">
        <div class="col-sm-12">
          <div class="form-group">
            <label>Client <span class="text-danger">*</span></label>
            <app-entity-finder [class]="'Customer'" [groups]="['customer']" [required]="!customerUuid"
              (uuid)="setCustomerUuid($event)" [selected]="customerSelected" [disabled]="!!customerUuid"
              [placeholder]="'Sélectionnez un client'" [ngClass]="{'is-invalid': submit && f.customer.errors}">
            </app-entity-finder>
            <div class="invalid-feedback" *ngIf="submit && f.customer.errors">
              <div *ngIf="f.customer.errors.required">{{ required.novide }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Affichage du solde actuel du wallet -->
    <div class="col-md-12 mb-4" *ngIf="wallet && !loadingWallet">
      <div class="card border-info">
        <div class="card-body">
          <h6 class="card-title">
            <i class="fas fa-wallet mr-2"></i>
            Solde actuel du wallet
          </h6>
          <p class="card-text">
            <span class="font-weight-bold" [ngClass]="{
                    'text-success': (wallet.solde || 0) > 0,
                    'text-danger': (wallet.solde || 0) < 0,
                    'text-muted': (wallet.solde || 0) === 0
                  }">
              {{ formatMontant(wallet.solde || 0) }}
            </span>
          </p>
          <small class="text-muted" *ngIf="wallet.creditDisponible > 0">
            Crédit disponible: {{ formatMontant(wallet.creditDisponible) }}
          </small>
        </div>
      </div>
    </div>

    <!-- Loader pour le chargement du wallet -->
    <div class="col-md-12 mb-4" *ngIf="loadingWallet">
      <div class="text-center">
        <i class="fas fa-spinner fa-spin"></i> Chargement du wallet...
      </div>
    </div>

    <div class="col-md-12">
      <div class="row">
        <span class="badge badge-primary my-2 f-14 formBadge width">
          Informations de la transaction
        </span>
      </div>

      <!-- Type de transaction -->
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group">
            <label>Type de transaction <span class="text-danger">*</span></label>
            <div class="btn-group btn-group-toggle w-100" data-toggle="buttons">
              <label *ngFor="let type of typeTransaction" class="btn btn-outline-secondary"
                [class.active]="f.type.value === type.value" [ngClass]="type.class">
                <input type="radio" [value]="type.value" formControlName="type" (change)="onMontantChange()">
                <i class="fas" [ngClass]="type.icon"></i>
                {{ type.label }}
              </label>
            </div>
            <div class="invalid-feedback" *ngIf="submit && f.type.errors">
              <div *ngIf="f.type.errors.required">{{ required.novide }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- Montant -->
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group">
            <label>Montant <span class="text-danger">*</span></label>
            <input type="number" class="form-control" formControlName="montant" placeholder="Entrez le montant" min="1"
              step="1" (input)="onMontantChange()">
            <div class="invalid-feedback" *ngIf="submit && f.montant.errors">
              <div *ngIf="f.montant.errors.required">{{ required.novide }}</div>
              <div *ngIf="f.montant.errors.min">Le montant doit être supérieur à 0</div>
              <div *ngIf="f.montant.errors.soldeInsuffisant" class="text-danger">
                <i class="fas fa-exclamation-triangle"></i>
                Solde insuffisant. Solde actuel: {{ formatMontant(wallet?.solde || 0) }}
              </div>
            </div>
            <small class="form-text text-muted">
              Montant en {{ global.device }}
            </small>
          </div>
        </div>
      </div>

      <!-- Libellé (optionnel) -->
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group">
            <label>Libellé (optionnel)</label>
            <textarea class="form-control" formControlName="libelle" rows="3"
              placeholder="Description de la transaction (optionnel)"></textarea>
            <small class="form-text text-muted">
              Si non renseigné, un libellé par défaut sera généré automatiquement
            </small>
          </div>
        </div>
      </div>

      <!-- Aperçu de la transaction -->
      <div class="row" *ngIf="f.montant.value && !f.montant.errors && wallet">
        <div class="col-sm-12">
          <div class="alert" [ngClass]="{
                 'alert-success': f.type.value === 'DEPOT',
                 'alert-warning': f.type.value === 'RETRAIT'
               }">
            <h6>
              <i class="fas fa-info-circle mr-2"></i>
              Aperçu de la transaction
            </h6>
            <p class="mb-1">
              <strong>Solde actuel :</strong> {{ formatMontant(wallet.solde || 0) }}
            </p>
            <p class="mb-1">
              <strong>{{ f.type.value === 'DEPOT' ? 'Dépôt' : 'Retrait' }} :</strong>
              <span [ngClass]="f.type.value === 'DEPOT' ? 'text-success' : 'text-danger'">
                {{ f.type.value === 'DEPOT' ? '+' : '-' }}{{ formatMontant(parseFloat(f.montant.value) || 0) }}
              </span>
            </p>
            <p class="mb-0">
              <strong>Nouveau solde :</strong>
              <span class="font-weight-bold" [ngClass]="{
                      'text-success': getNewSolde() > 0,
                      'text-danger': getNewSolde() < 0,
                      'text-muted': getNewSolde() === 0
                    }">
                {{ formatMontant(getNewSolde()) }}
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="onClose()" [disabled]="loading">
      <i class="feather icon-x-circle"></i> Annuler
    </button>
    <button type="submit" class="btn" [ngClass]="{
              'btn-success': f.type.value === 'DEPOT',
              'btn-danger': f.type.value === 'RETRAIT'
            }" [disabled]="loading || form.invalid || loadingWallet || !f.customer.value">
      <span *ngIf="loading">
        <i class="fas fa-spinner fa-spin"></i> Traitement...
      </span>
      <span *ngIf="!loading">
        <i class="fas" [ngClass]="f.type.value === 'DEPOT' ? 'fa-arrow-down' : 'fa-arrow-up'"></i>
        Confirmer le {{ f.type.value === 'DEPOT' ? 'dépôt' : 'retrait' }}
      </span>
    </button>
  </div>
</form>